module.exports = __webpack_public_path__ + "img/about-1.457e9e6f.jpg";